import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const DentalNav = () => {
  const theme = useTheme();

  const { t } = useTranslation();
  const [value, setValue] = useState("/dental");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/dental",
      "/dental/new-patient",
      "/dental/patient-list",
      "/dental/procedures",
      "/dental/patient-treatments",
      "/dental/patient-treatments-list",
      "/dental/prescription",
    ];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/dental");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental" ? theme.palette.primary.main : "white",
                color: value === "/dental" ? "white" : "black",
              }}
              label={t("dental.dashboard")}
              value="/dental"
              component={NavLink}
              to="/dental"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental/new-patient"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/dental/new-patient" ? "white" : "black",
              }}
              label={t("reception.newPatient")}
              value="/dental/new-patient"
              component={NavLink}
              to="/dental/new-patient"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental/patient-list"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/dental/patient-list" ? "white" : "black",
              }}
              label={t("reception.patientList")}
              value="/dental/patient-list"
              component={NavLink}
              to="/dental/patient-list"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental/procedures"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/dental/procedures" ? "white" : "black",
              }}
              label={t("dental.procedures")}
              value="/dental/procedures"
              component={NavLink}
              to="/dental/procedures"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental/patient-treatments"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/dental/patient-treatments" ? "white" : "black",
              }}
              label={t("dental.patientTreatments")}
              value="/dental/patient-treatments"
              component={NavLink}
              to="/dental/patient-treatments"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental/patient-treatments-list"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/dental/patient-treatments-list"
                    ? "white"
                    : "black",
              }}
              label={t("dental.patientTreatmentsList")}
              value="/dental/patient-treatments-list"
              component={NavLink}
              to="/dental/patient-treatments-list"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/dental/prescription"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/dental/prescription" ? "white" : "black",
              }}
              label={t("dental.prescription")}
              value="/dental/prescription"
              component={NavLink}
              to="/dental/prescription"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default DentalNav;
